import api from './api';

class OutletService {
  // Get all outlets (admin)
  async getOutlets() {
    const response = await api.get('/outlets/');
    return response.data;
  }

  // Get single outlet
  async getOutlet(id) {
    const response = await api.get(`/outlets/${id}`);
    return response.data;
  }

  // Create outlet
  async createOutlet(outletData) {
    const response = await api.post('/outlets', outletData);
    return response.data;
  }

  // Update outlet
  async updateOutlet(id, outletData) {
    const response = await api.put(`/outlets/${id}`, outletData);
    return response.data;
  }

  // Delete outlet (soft delete)
  async deleteOutlet(id) {
    const response = await api.delete(`/outlets/${id}`);
    return response.data;
  }

  // Toggle outlet status
  async toggleOutletStatus(id) {
    const response = await api.patch(`/outlets/${id}/toggle`);
    return response.data;
  }

  // Get outlet with menu
  async getOutletMenu(id) {
    const response = await api.get(`/outlets/${id}/menu`);
    return response.data;
  }

  // Get public outlets (for customer selection)
  async getPublicOutlets() {
    const response = await api.get('/outlets/public');
    return response.data;
  }

  async getTaxDetails(outlet_id){
    const response = await api.get(`/outlets/public/tax/${outlet_id}`);
    return response.data;
  }

  // Get public outlet with menu
  async getPublicOutlet(id) {
    const response = await api.get(`/outlets/public/${id}`);
    return response.data;
  }
}

export default new OutletService();
